import { Box, Typography } from '@mui/material';

interface ImageWithDescriptionProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export default function ImageWithDescription(props: ImageWithDescriptionProps) {
  const { icon, title, description } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '330px',
        rowGap: 1,
        textAlign: 'left',
      }}
    >
      <Box sx={{ fontSize: '40px', marginBottom: '20px' }}>{icon}</Box>
      <Typography fontSize={'40px'} fontWeight={600} color={'primary.main'}>
        {title}
      </Typography>
      <Typography fontSize={'20px'} fontWeight={300} color={'text.primary'}>
        {description}
      </Typography>
    </Box>
  );
}
